var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarSelect = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.004,
    viewBox: "0 0 22 22.004",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8024",
    "data-name": "Group 8024",
    transform: "translate(-533.5 -438.401)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9988",
    "data-name": "Rectangle 9988",
    width: 22,
    height: 22.004,
    rx: 2,
    transform: "translate(533.5 438.401)",
    fill: "#e5eaed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9783",
    "data-name": "Path 9783",
    d: "M320.206,229.6h0l3.549-.661,1.751-3.5,1.777,3.5,3.635.661-2.61,2.79.583,3.6-3.7-1.737-3.5,1.737.828-3.959L320.4,230.15",
    transform: "translate(219.134 218.687)",
    fill: "#126cfc"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarSelect);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMi4wMDQiIHZpZXdCb3g9IjAgMCAyMiAyMi4wMDQiPgogIDxnIGlkPSJHcm91cF84MDI0IiBkYXRhLW5hbWU9Ikdyb3VwIDgwMjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MzMuNSAtNDM4LjQwMSkiPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV85OTg4IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA5OTg4IiB3aWR0aD0iMjIiIGhlaWdodD0iMjIuMDA0IiByeD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTMzLjUgNDM4LjQwMSkiIGZpbGw9IiNlNWVhZWQiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk3ODMiIGRhdGEtbmFtZT0iUGF0aCA5NzgzIiBkPSJNMzIwLjIwNiwyMjkuNmgwbDMuNTQ5LS42NjEsMS43NTEtMy41LDEuNzc3LDMuNSwzLjYzNS42NjEtMi42MSwyLjc5LjU4MywzLjYtMy43LTEuNzM3LTMuNSwxLjczNy44MjgtMy45NTlMMzIwLjQsMjMwLjE1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTkuMTM0IDIxOC42ODcpIiBmaWxsPSIjMTI2Y2ZjIi8+CiAgPC9nPgo8L3N2Zz4K";